@charset "UTF-8";

/* src/app/forms/importacao-dados/json-config/json-config.component.scss */
h1 {
  color: #3f51b5;
  font-size: 1.5em;
  margin-bottom: 15px;
  text-align: center;
}
.mat-mdc-table {
  width: 100%;
}
.mat-mdc-header-cell,
.mat-mdc-cell {
  flex: 1 1 0px;
}
.mat-mdc-form-field {
  width: 100%;
}
.mat-mdc-dialog-actions {
  justify-content: center;
  margin-top: 15px;
}
button {
  margin: 0 10px;
}
table {
  width: 100%;
  table-layout: fixed;
}
.cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.mat-mdc-row,
.mat-mdc-header-row {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}
.mat-mdc-cell,
.mat-mdc-header-cell {
  flex-basis: 0;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mat-mdc-cell {
  flex-basis: 0;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mat-mdc-header-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mat-mdc-dialog-actions {
  justify-content: flex-end;
  margin-top: 15px;
  overflow: hidden;
  width: 100%;
  margin-bottom: 0px;
}
button {
  margin: 0 10px;
  padding: 6px 12px;
  font-size: 14px;
}
button[color=warn] {
  background-color: #f44336;
  color: white;
}
button[color=primary] {
  background-color: #3f51b5;
  color: white;
}
.custom-dialog-container {
  margin: 0px !important;
}
.margin-left-btn {
  margin-left: 48px;
}
.header-config {
  margin-bottom: 10px;
}
.marginLeftIcon {
  margin-left: -40px;
}
.margin-top16 {
  margin-top: 14px;
}
.marginLeft {
  margin-left: 10px;
}
.example-full-width {
  width: 100%;
}
mat-spinner {
  width: 50px;
  height: 50px;
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.endpoint {
  width: 50%;
}
.token {
  margin-left: 27px;
}
.tokenForm {
  margin-top: 5px;
}
.load-json-button {
  line-height: 25px;
  margin-left: -1px;
}
.textJson {
  border: 1px solid;
}
.loadJsonPersonalized {
  margin-top: 10px;
  line-height: 25px;
  margin-left: -1px;
}
.container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.json-keys {
  max-width: 300px;
  height: 400px;
  overflow-y: auto;
}
.json-key {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.json-key span {
  margin-right: 20px;
}
.table-cards {
  flex-grow: 1;
}
mat-expansion-panel {
  margin-bottom: 20px;
}
mat-list-item {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
  cursor: move;
}
cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.15);
}
cdk-drag-placeholder {
  opacity: 0;
}
cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
mat-list.cdk-drop-list-dragging .mat-mdc-list-item:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
/*# sourceMappingURL=json-config.component.css.map */
